import { useMemo } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useGetOrders, useGetSellerOrdersCountByStatus } from '~/api';
import { calculateOrderTotal, formatCurrency, formatDate } from '~/utils';
import { ShipmentOrdersColumn } from './shared/ShipmentOrdersColumn';

export function ReadyToShipColumn() {
  const { t } = useTranslation('dashboard');
  const { data, isLoading, isError } = useGetOrders('SELLING', 'CONFIRMED');
  const { data: countData } = useGetSellerOrdersCountByStatus();

  const confirmedCount = countData?.sellerOrdersCount?.confirmed;

  const sortedOrders = useMemo(() => {
    if (!data?.orders?.content) return [];
    return [...data.orders.content]
      .sort((a, b) => {
        if (a.deliveryStartDate == null && b.deliveryStartDate == null)
          return 0;
        if (a.deliveryStartDate == null) return 1;
        if (b.deliveryStartDate == null) return -1;
        return (
          new Date(a.deliveryStartDate).getTime() -
          new Date(b.deliveryStartDate).getTime()
        );
      })
      .slice(0, 5);
  }, [data]);

  return (
    <ShipmentOrdersColumn
      title={t('dashboard.seller_ready_to_ship.title')}
      subtitle={t('dashboard.seller_ready_to_ship.subtitle')}
      badge={confirmedCount}
      footerLink="/seller-orders/confirmed"
      footerLabel={t('dashboard.seller_ready_to_ship.footer')}
      orders={sortedOrders}
      isLoading={isLoading}
      isError={isError}
      emptyText={t('dashboard.seller_ready_to_ship.empty')}
      errorText={t('dashboard.seller_ready_to_ship.error')}
      getOrgLabel={(order) => order.buyingOrganization?.name ?? ''}
      renderRowTopRight={(order) => {
        const total = calculateOrderTotal(order);
        return (
          <span className="text-sm font-medium text-neut-prim">
            {total != null && total > 0
              ? formatCurrency(
                  total,
                  order.currency ?? order.items[0]?.effectivePrice?.currency
                )
              : '—'}
          </span>
        );
      }}
      renderDateMeta={(order) => ({
        row3Right: (
          <Link
            to={`/orders/view/${order.id}?returnPath=/dashboard`}
            className="px-2 py-0.5 rounded text-xs font-medium transition-colors bg-prim text-white hover:bg-prim-700 shrink-0"
          >
            {t('dashboard.seller_ready_to_ship.mark_shipped_button')}
          </Link>
        ),
        row4Right: order.deliveryStartDate ? (
          <p className="text-xs font-medium text-neut-400 shrink-0">
            {formatDate(order.deliveryStartDate)}
          </p>
        ) : null,
      })}
      showPrice={false}
    />
  );
}
